import * as React from "react";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";

const MenuIcon = ({ customColor, ...props }) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_8519_8195)">
            <Path d="M2 12H14V10.6667H2V12ZM2 8.66667H14V7.33333H2V8.66667ZM2 4V5.33333H14V4H2Z" fill={customColor || "#521FAC"} />
        </G>
        <Defs>
            <ClipPath id="clip0_8519_8195">
                <Rect width="16" height="16" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);

export default MenuIcon;
